
class Login extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.recoveryForm = this.element.querySelector("#ForgotPass");
    this.loginForm = this.element.querySelector("#logIn");

    if (window.location.href.indexOf("recover") != -1) {
      this.openRecover();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-recovery"]',
      this.openRecover.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-login"]',
      this.openLogin.bind(this)
    );

  }

  connectedCallback() {
    this.initFormValidation();
  }

  openRecover(event = null) {
    if (event) event.preventDefault();
    this.recoveryForm.setAttribute('aria-hidden', 'false');
    this.loginForm.setAttribute('aria-hidden', 'true');
  }

  openLogin(event = null) {
    if (event) event.preventDefault();
    this.recoveryForm.setAttribute('aria-hidden', 'true');
    this.loginForm.setAttribute('aria-hidden', 'false');
  }



  initFormValidation() {
    const forms = {
      login: { el: "#customer_login", button: ".acc_login-btn", error: ".input-validation" },
      register: { el: "#register_form", button: ".acc_login-btn, .Button--auth", error: ".registerErrors" },
      recover: { el: "#recover_form", button: ".acc_forgot-btn", error: "#RecoverEmail-email-error" },
      reset: { el: "#reset_form", button: ".acc_reset-btn", error: ".input-validation" }
    };

    for (const [key, { el, button, error }] of Object.entries(forms)) {
      const form = this.querySelector(el);
      if (!form) continue;

      this[`${key}Validator`] = new FormValidator(form, {
        errorClass: "field--error",
        fieldSelector: ".field",
        buttonSelector: button,
        fieldErrorSelector: error,
        validateOnBlur: true,
        validateOnInput: false,
        showErrorsOnSubmitOnly: false
      });
    }
  }

}

customElements.define("customer-login", Login);


class AccountComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);


    this.accountHeader = this.element.querySelector('.customerAccount--Header');

    this.bindEvents();
  }


  connectedCallback() {
    this.adjustAddAddressButton();
    this.handleRefreshState();


  }



  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-subtab"]', this.toggleSubTab.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-back"]', this.toggleBack.bind(this));
    this.delegateElement.on("click", '[data-action="delete-address"]', this.deleteAddress.bind(this));
  }


  handleRefreshState() {
    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.element.querySelector('#contactInfo').setAttribute('aria-visible', 'true');
    }

    const searchParams = new URLSearchParams(window.location.search);
    const param1Value = searchParams.get('location');

    if (param1Value) {
      this.toggleTab(false, param1Value);
    } else {
      this.toggleTab(false, 'contactInfo');
    }
  }

  deleteAddress(event) {
    const id = event.target.getAttribute("data-id");
    Shopify.postLink("/account/addresses/" + id, { parameters: { _method: "delete" } });
    setTimeout(() => {
      const currentUrl = new URL(window.location.href);
      window.location.href = currentUrl.href;
    }, 500);
  }

  toggleBack() {
    const menuTab = this.element.querySelector('.customerAccount--Menu');
    if (menuTab) {
      menuTab.style.display = "flex";
    }

    if (this.accountHeader) {
      this.accountHeader.style.display = "block";
    }

    const allContent = this.element.querySelectorAll('.customerAccount--Content');
    allContent.forEach((content) => {
      if (content.id == "activeOrders" || content.id == "orderHistory") return;
      content.setAttribute('aria-visible', 'false');
    });
  }

  toggleTab(event, paramValue) {
    let id = paramValue;
    if (event) {
      id = event.target.dataset.id;
    }

    const allTabs = this.element.querySelectorAll('.customerAccount--MenuTab');
    const allContent = this.element.querySelectorAll('.customerAccount--Content');
    const menuTab = this.element.querySelector('.customerAccount--Menu');

    if (responsive.matchesBreakpoint('pocket')) {
      if (this.accountHeader) {
        this.accountHeader.style.display = "none";
      }
      if (menuTab) {
        menuTab.style.display = "none";
      }
    }

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
      tab.classList.remove('account-menu_active');
    });

    const activeTab = this.element.querySelector(`[data-id="${id}"]`);
    if (activeTab) {
      activeTab.setAttribute('aria-expanded', 'true');
      activeTab.classList.add('account-menu_active');
    }

    allContent.forEach((content) => {
      if (!content.classList.contains('customerAccount--ContentOrders')) {
        content.setAttribute('aria-visible', 'false');
      }
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }

    const currentUrl = window.location.href.split('?')[0];
    const newUrl = `${currentUrl}?location=${id}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
  }

  adjustAddAddressButton(event = null) {
    const menu = this.element.querySelector(".customerAccount--Menu");
    const button = event
      ? event.target.closest(".add-address-btn_desk")
      : this.element.querySelector(".add-address-btn_desk");

    console.log("Menu:", menu);
    console.log("Button:", button);

    if (menu && button) {
      const height = menu.offsetHeight;
      button.style.marginTop = `calc(${height}px + 1.5rem)`;
      console.log("Applied marginTop:", height);
    }
  }





  toggleSubTab(event) {
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll('.customerAccount--toggleTab');
    const allContent = this.element.querySelectorAll('.customerAccount--ContentOrders');

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    event.target.setAttribute('aria-expanded', 'true');

    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }
  }
}

customElements.define("account-component-inner", AccountComponent);
